<template>
  <div id="app">
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" /> -->
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
import { ElConfigProvider } from "element-plus";
import zhcn from "element-plus/lib/locale/lang/zh-cn";

export default {
  name: "App",
  components: {
    [ElConfigProvider.name]: ElConfigProvider,
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },
  setup() {
    // 中文
    let locale = zhcn;
    return {
      locale,
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
  },
};
</script>

<style>
#app {
  height: 100vh;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}

body {
  font-family: "Microsoft YaHei", "微软雅黑", Arial, Helvetica, sans-serif,"宋体";
  /* font-size:14px; */
}
textarea {
  font-family: "Microsoft YaHei", "微软雅黑", Arial, Helvetica, sans-serif,"宋体";
}
/* "Microsoft YaHei", "微软雅黑", Arial, Helvetica, sans-serif,"宋体"; */
/* 'PingFang SC', 'Microsoft YaHei',Arial, sans-serif; */
.el-table .cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/**修改全局的滚动条*/
/**滚动条的宽度*/
::-webkit-scrollbar {
  width: 8px;
}
/* 滚动条的滑块 */
::-webkit-scrollbar-thumb {
  background-color: #eaecf1;
  border-radius: 3px;
}
/* 气泡滚动条的滑块 */
/* .el-popover{
  height: 200px; 
  overflow: auto;
} */

</style>
